import React, { useState, useRef, useEffect } from 'react';

import { DiffContent } from '@atlassian/bitkit-diff';

import { CodemirrorDiffEditorLite } from './codemirror-diff-editor-lite';
import { getDiffContentWithoutPrefix, getDiffStartLineNum } from './utils';

interface CodeSuggestionEditorProps {
  diffLine: DiffContent;
  nodeLocalId: string | undefined;
  saveSuggestion: (suggestion: Record<string, string>) => void;
  suggestionText?: string;
  handleKeyDown: any;
}

export const CodeSuggestionEditor = React.memo(function CodeSuggestionEditor({
  diffLine,
  nodeLocalId,
  saveSuggestion,
  suggestionText,
  handleKeyDown,
}: CodeSuggestionEditorProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const originalCode = getDiffContentWithoutPrefix(diffLine);
  const [suggestion, setSuggestion] = useState(suggestionText || originalCode);

  // save the suggestion when the component mounts
  useEffect(() => {
    if (nodeLocalId) {
      saveSuggestion({ [nodeLocalId]: suggestion });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSuggestionChange = (newSuggestion: string) => {
    setSuggestion(newSuggestion);

    if (!nodeLocalId) {
      return;
    }

    saveSuggestion({ [nodeLocalId]: newSuggestion });
  };

  return (
    <div ref={wrapperRef}>
      <CodemirrorDiffEditorLite
        startLineNum={getDiffStartLineNum(diffLine)}
        originalCode={originalCode}
        updatedCode={suggestion}
        onChange={handleSuggestionChange}
        handleKeyDown={handleKeyDown}
        nodeLocalId={nodeLocalId}
      />
    </div>
  );
});
